// Shared helper for giving each person a consistent, distinct avatar color
// (by hashing their id/name) instead of one flat shared color everywhere.

const AVATAR_PALETTE = ["#2563eb", "#dc2626", "#16a34a", "#ca8a04", "#7c3aed", "#db2777", "#0891b2", "#ea580c", "#4f46e5", "#059669", "#be123c", "#0d9488"];

export const avatarColorOf = (key) => {
  const str = String(key ?? "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};
